import { all } from 'redux-saga/effects';

import fittestBookingSaga from './fittest-booking-saga';

export default function* rootSaga() {
  yield all([fittestBookingSaga()]);
}
